import { ReactNode, useEffect, VFC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from './reducks/store/store';
import { listenAuthState } from './reducks/users/operations';
import {getIsSignedIn, getRole} from './reducks/users/selectors';
import { useNavigate } from 'react-router-dom';

type Props = {
  children: ReactNode;
  roles: string[];
};

export const Auth: VFC<Props> = (props) => {
  const { children, roles } = props;

  const dispatch = useDispatch();
  const selector = useSelector((state: RootState) => state);
  const isSignedIn = getIsSignedIn(selector);
  const role = getRole(selector);
  const navigate = useNavigate();

  useEffect(() => {
    // サインインしていなければ、ListenAuthState関数を呼んでリッスン
    if (!isSignedIn) {
      dispatch(listenAuthState(navigate));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

   // ログインしていなければ、空の画面を表示
  if (!isSignedIn || !roles.includes(role)) {
    return <></>;
  }

  // ログインしていれば、childrenとして渡ってきた画面を表示
  return <>{children}</>;
};
